$(document).ready(function () {
  if ($(".open_menu_mobile").length > 0) {
    $(".open_menu_mobile").click(function () {
      if ($(".topmenu").hasClass("d-none-mobile")) {
        $(".topmenu").removeClass("d-none-mobile")
        $(".topmenu .close_menu").click(function () {
          $(".topmenu").addClass("d-none-mobile")
        })
      } else {
        $(".topmenu").addClass("d-none-mobile")
        $(".topmenu").css("display", "none")
      }
    })
  }

  jQuery(".filter-toggle").on("click", function (e) {
    e.preventDefault()
    jQuery(this).toggleClass("active")
    jQuery(".filter-toggle-wrap").slideToggle("is-visible")
  })

  var filter = jQuery(this).find(".full_width .sorting_wrapper")

  jQuery(this).find(".filter-toggle").insertBefore(filter)
  jQuery("#column-right").insertAfter("#content")
  jQuery(
    "#shopify-section-footer-style-3,#shopify-section-footer-style-2, #shopify-section-footer-style-1"
  ).appendTo(".site-inner")

  jQuery(".header_style_1 #shopify-section-TT-mega_menu").insertBefore(
    ".header_style_1 .header-middle"
  )

  jQuery(".header_style_2 #shopify-section-TT-mega_menu").insertBefore(
    ".header_style_2 .menu-bar .topmenu"
  )
  jQuery(".header_style_3 #shopify-section-TT-mega_menu").insertBefore(
    ".header_style_3 .header-middle"
  )

  jQuery(".tt-flexslider, .category-featured").prependTo(
    ".site-inner .main-content"
  )

  jQuery(".tt-flexslider").wrapAll(
    '<div class="container-fluid p-0"><div class="row"></div></div>'
  )

  jQuery(
    ".shopify-section.Testimonial, .shopify-section.bottom-banner"
  ).wrapAll('<div class="container"><div class="row"></div></div>')

  jQuery(".slider-newproduct .product-wrapper").each(function () {
    var prod_desc = jQuery(this).find(
      ".product-description .product-description-wrap"
    )

    jQuery(this).find(".btn_wrapper").appendTo(prod_desc)

    var prod_desc = jQuery(this).find(
      ".product-description .product-description-wrap .btn_wrapper"
    )

    jQuery(this)
      .find(".flip-countdown.simple-countdown")
      .insertBefore(prod_desc)

    var prod_desc = jQuery(this).find(
      ".product-description .product-description-wrap"
    )

    jQuery(this).find(".grid-view-item__title").prependTo(prod_desc)

    var prod_desc = jQuery(this).find(
      ".product-description .flip-countdown.simple-countdown"
    )

    jQuery(this).find(".ttqtyprogress").insertBefore(prod_desc)

    var prod_clr = jQuery(this).find(
      ".product-description .grid-view-item__meta"
    )

    jQuery(this).find(".color_swatch_Value").insertAfter(prod_clr)
  })

  jQuery(".category-slider .product-wrapper").each(function () {
    var prod_desc = jQuery(this).find(
      ".product-description .product-description-wrap"
    )

    jQuery(this).find(".h4.grid-view-item__title").prependTo(prod_desc)

    var prod_ven = jQuery(this).find(
      ".product-description .product-description-wrap"
    )

    jQuery(this).find(".grid-view-item__vendor").prependTo(prod_desc)
  })

  jQuery("#tt-megamenu span.toggle_menu").click(function (event) {
    jQuery(this).toggleClass("active")
    event.stopPropagation()
    jQuery(".tt-mega-menu #tt-megamenu .tt-mega_menu").slideToggle("2000")
  })

  jQuery(".tt-mega-menu #tt-megamenu .tt-mega_menu").on(
    "click",
    function (event) {
      event.stopPropagation()
    }
  )

  if (jQuery(".header_1 .wrapper-wrap").hasClass("logo_center")) {
    jQuery("body").addClass("logo_center")
  }

  var w_width = $(window).width()

  $(".slider-content-main-wrap").css("width", w_width)

  if ($(".site-header").hasClass("header_transaparent")) {
    $("body.template-index").addClass("header_transaparent")
  }

  $(".fixed .mini-cart-wrap").perfectScrollbar()

  var img_id = jQuery(".product-single__thumbs .slick-active.slick-current")
    .find(".product-single__thumb")
    .data("id")
  if (jQuery(".product-lightbox-btn").hasClass(img_id)) {
    jQuery(".product-lightbox-btn." + img_id).show()
  }

  jQuery(".filter-left").on("click", function (e) {
    e.preventDefault()
    jQuery(this).toggleClass("active")
    jQuery(".off-canvas.position-left").toggleClass("is-open")
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").toggleClass(
      "is-visible is-closable"
    )
  })
  jQuery(".is-overlay-fixed").on("click", function (e) {
    e.preventDefault()
    jQuery(".filter-left").trigger("click")
    jQuery(".filter-right").trigger("click")
  })
  jQuery(".filter-right").on("click", function (e) {
    e.preventDefault()
    jQuery(this).toggleClass("active")
    jQuery(".off-canvas.position-right").toggleClass("is-open")
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").toggleClass(
      "is-visible is-closable"
    )
  })
  $(".product-360-button a").magnificPopup({
    type: "inline",
    mainClass: "mfp-fade",
    removalDelay: 160,
    disableOn: false,
    preloader: false,
    fixedContentPos: false,
    callbacks: {
      open: function () {
        $(window).resize()
      },
    },
  })

  /* coundown js */
  //countDownProductIni('.js-flip-countdown');
  /* simple countdown */
  countDownIni(".flip-countdown,.js-flip-countdown")
  /***/
  /** popup Video **/

  $(".popup-video").magnificPopup({
    disableOn: 300,
    type: "iframe",
    mainClass: "mfp-fade",
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
  })

  /***/

  if (
    $("a.product-lightbox-btn").length > 0 ||
    $("a.product-video-popup").length > 0
  ) {
    $(".product-single__photos .gallery,.design_2 .product-img").magnificPopup({
      delegate: "a", // child items selector, by clicking on it popup will open
      type: "image",
      tLoading:
        '<div class="please-wait dark"><span></span><span></span><span></span></div>',
      removalDelay: 300,
      closeOnContentClick: true,
      gallery: {
        enabled: true,
        navigateByImgClick: false,
        preload: [0, 1],
      },
      image: {
        verticalFit: false,
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      },
      callbacks: {
        beforeOpen: function () {
          var productVideo = $(".product-video-popup").attr("href")
          if (productVideo) {
            this.st.mainClass = "has-product-video"
            var galeryPopup = $.magnificPopup.instance
            galeryPopup.items.push({
              src: productVideo,
              type: "iframe",
            })
            galeryPopup.updateItemHTML()
          }
        },
        open: function () {},
      },
      // other options
    })
  }
  $(".design_3 .product-img,.design_5 .pro_img").magnificPopup({
    delegate: "a", // child items selector, by clicking on it popup will open
    type: "image",
    tLoading:
      '<div class="please-wait dark"><span></span><span></span><span></span></div>',
    removalDelay: 300,
    closeOnContentClick: true,
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      preload: [0, 1],
    },
    image: {
      verticalFit: false,
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
    },
    callbacks: {
      beforeOpen: function () {
        var productVideo = $(".product-video-popup").attr("href")
        if (productVideo) {
          this.st.mainClass = "has-product-video"
          var galeryPopup = $.magnificPopup.instance
          galeryPopup.items.push({
            src: productVideo,
            type: "iframe",
          })
          galeryPopup.updateItemHTML()
        }
      },
      open: function () {},
    },
    // other options
  })
  $("body").on("click", ".product-lightbox-btn", function (e) {
    $(".product-wrapper-owlslider").find(".owl-item.active a").click()
    e.preventDefault()
  })

  jQuery(".fullscreen_header_toggle").on("click", function (e) {
    e.preventDefault()
    jQuery(this).toggleClass("active")
    jQuery(".fullscreen_header").toggleClass("nav-open")
    jQuery("body").toggleClass("fullnav-open header_2")
  })

  /* start vertical js*/
  if (jQuery(".leftmenu_header").length > 0) {
    if (jQuery(".leftmenu_header_fixed.leftmenu_header").length > 0) {
      if (
        jQuery(".leftmenu_header_fixed.leftmenu_header").hasClass("menu_left")
      ) {
        jQuery("body").addClass("menu_left")
      }
      if (
        jQuery(".leftmenu_header_fixed.leftmenu_header").hasClass("menu_right")
      ) {
        jQuery("body").addClass("menu_right")
      }
    }
    jQuery(".leftmenu_header").on("click", function (e) {
      e.preventDefault()
      jQuery(this).toggleClass("active")
      jQuery("body").toggleClass("nav-open")
    })
  }
  /* end vertical js*/

  $(".qtyplus").on("click", function (e) {
    e.preventDefault()
    var input_val = jQuery(this).parents(".qty-box-set").find(".quantity")
    var currentVal = parseInt(
      jQuery(this).parents(".qty-box-set").find(".quantity").val()
    )
    if (!isNaN(currentVal)) {
      jQuery(this)
        .parents(".qty-box-set")
        .find(".quantity")
        .val(currentVal + 1)
    } else {
      jQuery(this).parents(".qty-box-set").find(".quantity").val(1)
    }
  })

  $(".qtyminus").on("click", function (e) {
    e.preventDefault()
    var input_val = jQuery(this).parents(".qty-box-set").find(".quantity")
    var currentVal = parseInt(
      jQuery(this).parents(".qty-box-set").find(".quantity").val()
    )
    if (!isNaN(currentVal) && currentVal > 1) {
      jQuery(this)
        .parents(".qty-box-set")
        .find(".quantity")
        .val(currentVal - 1)
    } else {
      jQuery(this).parents(".qty-box-set").find(".quantity").val(1)
    }
  })
  $("#navToggle").on("click", function (e) {
    jQuery(this).next(".Site-navigation").slideToggle(500)
  })
  $(".menu_toggle_wrap #navToggle").on("click", function (e) {
    jQuery(this).parent().next(".Site-navigation").slideToggle(500)
  })

  /*Scroll to top js*/
  jQuery("#GotoTop").on("click", function () {
    jQuery("html, body").animate(
      {
        scrollTop: 0,
      },
      "1000"
    )
    return false
  })

  jQuery(".site-header__search.search-full .serach_icon").on(
    "click",
    function (e) {
      e.preventDefault()
      jQuery(this).toggleClass("active")
      jQuery("body").toggleClass("search_full_active")
      jQuery(".full-search-wrapper").addClass("search-overlap")
      jQuery(".search-bar > input").focus()
    }
  )
  jQuery(".site-header__search.search-full .close-search").on(
    "click",
    function () {
      jQuery(".site-header__search.search-full .serach_icon").removeClass(
        "active"
      )
      jQuery(".full-search-wrapper").removeClass("search-overlap")
      jQuery("body").removeClass("search_full_active")
    }
  )

  jQuery(".site-header__search:not(.search-full) .serach_icon").on(
    "click",
    function () {
      jQuery(".search_wrapper").slideToggle("fast")
      jQuery(".search-bar > input").focus()
      jQuery(this).toggleClass("active")
      jQuery(".customer_account").slideUp("fast")
      jQuery("#slidedown-cart").slideUp("fast")
      jQuery("#Sticky-slidedown-cart").slideUp("fast")
    }
  )
  jQuery(".myaccount  .dropdown-toggle").on("click", function (event) {
    event.preventDefault()
    // if($(".currency-block")[0]){$(".currency-block > ul").css('display','none');  $(".header_currency .currency_wrapper.dropdown-toggle").removeClass('active'); }

    jQuery(".customer_account").slideToggle("fast")
    jQuery(".site-header__search:not(.search-full) .serach_icon").removeClass(
      "active"
    )
    jQuery("body").removeClass("search_full_active")
    jQuery(".site-header .search_wrapper").slideUp("fast")
    jQuery("#slidedown-cart").slideUp("fast")
    jQuery("#Sticky-slidedown-cart").slideUp("fast")
  })
  $(".header_currency .currency_wrapper.dropdown-toggle").on(
    "click",
    function (event) {
      event.preventDefault()
      jQuery(".customer_account").stop()
      jQuery(".currencies.flag-dropdown-menu").slideToggle("fast")
      $(this).toggleClass("active")
    }
  )
  var p_col = jQuery(".slider-newproduct").data("col")
  if (jQuery("body:not(.rtl)").hasClass("left_sidebar")) {
    $("body.left_sidebar:not(.rtl) .slider-newproduct").owlCarousel({
      items: p_col,
      nav: true,
      autoplay: true,
      autoplaySpeed: 1500,
      autoplayHoverPause: true,
      dots: false,
      responsive: {
        100: {
          items: 1,
        },
        543: {
          items: 1,
        },
        768: {
          items: 1,
        },
        992: {
          items: 2,
        },
        1200: {
          items: 2,
        },
        1600: {
          items: 2,
        },
        1700: {
          items: p_col,
        },
      },
    })
  } else {
    $("body:not(.rtl.left_sidebar) .slider-newproduct").owlCarousel({
      items: p_col,
      nav: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 1500,
      autoplayHoverPause: true,
      responsive: {
        100: {
          items: 1,
        },
        543: {
          items: 1,
        },
        768: {
          items: 1,
        },
        992: {
          items: 2,
        },
        1200: {
          items: 2,
        },
        1600: {
          items: 2,
        },
        1700: {
          items: p_col,
        },
      },
    })
  }

  if (jQuery("body.rtl.left_sidebar").hasClass("left_sidebar")) {
    $("body.rtl.left_sidebar .slider-newproduct").owlCarousel({
      items: p_col,
      nav: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 1500,
      autoplayHoverPause: true,
      rtl: true,
      responsive: {
        100: {
          items: 1,
        },
        543: {
          items: 1,
        },
        768: {
          items: 1,
        },
        992: {
          items: 2,
        },
        1200: {
          items: 2,
        },
        1600: {
          items: 2,
        },
        1700: {
          items: p_col,
        },
      },
    })
  } else {
    $("body.rtl:not(.left_sidebar) .slider-newproduct").owlCarousel({
      items: p_col,
      nav: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 1500,
      autoplayHoverPause: true,
      rtl: true,
      responsive: {
        100: {
          items: 1,
        },
        543: {
          items: 1,
        },
        768: {
          items: 1,
        },
        992: {
          items: 2,
        },
        1200: {
          items: 2,
        },
        1600: {
          items: 2,
        },
        1700: {
          items: p_col,
        },
      },
    })
  }

  $(".slider-newproduct-wrap").each(function () {
    if ($(this).find(".owl-nav").hasClass("disabled")) {
      $(this).find(".customNavigation").hide()
    } else {
      $(this).find(".customNavigation").show()
    }
  })
  $(".slider-newproduct-wrap .customNavigation .next").click(function () {
    var wrap = $(this).closest(".slider-newproduct-wrap")
    $(wrap).find(".slider-newproduct").trigger("next.owl")
  })
  $(".slider-newproduct-wrap .customNavigation .prev").click(function () {
    var wrap = $(this).closest(".slider-newproduct-wrap")
    $(wrap).find(".slider-newproduct").trigger("prev.owl")
  })

  $(".mobile-nav__sublist-trigger").on("click", function (evt) {
    evt.preventDefault()
    var $el = $(this)
    console.log($el)
    if ($el.hasClass("is-active")) {
      $el.removeClass("is-active")
      $el
        .parent()
        .parent()
        .find(".sub-nav__dropdown")
        .css("display", "none!important")
    } else {
      $el.addClass("is-active")
    }

    $el.parent().find(".tt_sub_menu_wrap").slideToggle(200)
  })

  /*$(".Site-navigation .header-icons-wrap").append($(".menu_toggle_wrap"));*/
  $(".slider-bestproduct .product-wrapper").each(function () {
    var $desc = $(this).find(".product-description .progress")
    var $qty = $(this).find(".quantity")
    var $pbar = $(this).find(".progress-bar")
    var $progress = $desc
    var $progressBar = $pbar
    var $quantity = $qty.html()
    var currentWidth = parseInt($progressBar.css("width"))
    var allowedWidth = parseInt($progress.css("width"))
    var addedWidth = currentWidth + parseInt($quantity)
    if (addedWidth > allowedWidth) {
      addedWidth = allowedWidth
    }
    var progress = (addedWidth / allowedWidth) * 100
    $progressBar.animate({ width: progress + "%" }, 100)
  })

  var p_col = jQuery(".slider-bestproduct").data("col")
  $("body:not(.rtl) .slider-bestproduct").owlCarousel({
    items: p_col,
    nav: true,
    autoplay: true,
    autoplaySpeed: 1500,
    dots: false,
    responsive: {
      100: {
        items: 1,
      },
      543: {
        items: 2,
      },
      768: {
        items: 2,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
      1660: {
        items: 5,
      },
      1700: {
        items: p_col,
      },
    },
  })

  $("body.rtl .slider-bestproduct").owlCarousel({
    items: p_col,
    nav: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 1500,
    responsive: {
      100: {
        items: 1,
      },
      543: {
        items: 2,
      },
      768: {
        items: 2,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
      1660: {
        items: 5,
      },
      1700: {
        items: p_col,
      },
    },
  })

  $(".slider-bestproduct-wrap").each(function () {
    if ($(this).find(".owl-nav").hasClass("disabled")) {
      $(this).find(".customNavigation").hide()
    } else {
      $(this).find(".customNavigation").show()
    }
  })
  $(".slider-bestproduct-wrap .customNavigation .next").click(function () {
    var wrap = $(this).closest(".slider-bestproduct-wrap")
    $(wrap).find(".slider-bestproduct").trigger("next.owl")
  })
  $(".slider-bestproduct-wrap .customNavigation .prev").click(function () {
    var wrap = $(this).closest(".slider-bestproduct-wrap")
    $(wrap).find(".slider-bestproduct").trigger("prev.owl")
  })

  $("body:not(.rtl) #ttcmsfooter-services .block_content").owlCarousel({
    items: 5,
    nav: true,
    dots: true,
    loop: true,
    autoplay: true,
    rtl: false,
    navText: [
      "<i class='fa fa-chevron-left'></i>",
      "<i class='fa fa-chevron-right'></i>",
    ],
    responsive: {
      1430: {
        items: 5,
      },
      1200: {
        items: 4,
      },
      992: {
        items: 3,
      },
      768: {
        items: 3,
      },
      100: {
        items: 2,
      },
    },
  })
  $("body.rtl #ttcmsfooter-services .block_content").owlCarousel({
    items: 5,
    nav: true,
    dots: true,
    loop: false,
    autoplay: true,
    rtl: true,
    navigationText: [
      "<i class='fa fa-angle-left'></i>",
      "<i class='fa fa-angle-right'></i>",
    ],
    responsive: {
      1430: {
        items: 5,
      },
      1200: {
        items: 4,
      },
      992: {
        items: 3,
      },
      768: {
        items: 3,
      },
      100: {
        items: 2,
      },
    },
  })

  var blogowlrtl = $("body.rtl .grid-blog-slider")
  $("body.rtl .grid-blog-slider").owlCarousel({
    items: 3,
    loop: false,
    nav: true,
    rtl: true,
    autoplayHoverPause: true,
    dots: false,
    responsive: {
      100: {
        items: 1,
      },
      543: {
        items: 2,
      },
      992: {
        items: 3,
      },
      1201: {
        items: 4,
      },
    },
  })

  var blogowl = $("body:not(.rtl) .grid-blog-slider")
  $("body:not(.rtl) .grid-blog-slider").owlCarousel({
    items: 3,
    loop: false,
    nav: true,
    rtl: false,
    autoplayHoverPause: true,
    dots: false,
    responsive: {
      100: {
        items: 1,
      },
      543: {
        items: 2,
      },
      992: {
        items: 3,
      },
      1201: {
        items: 4,
      },
    },
  })
  $(".grid--blog").each(function () {
    if ($(this).find(".owl-nav").hasClass("disabled")) {
      $(this).find(".customNavigation").hide()
    } else {
      $(this).find(".customNavigation").show()
    }
  })
  $(".blog_next").click(function () {
    $(".grid-blog-slider").trigger("next.owl")
  })
  $(".blog_prev").click(function () {
    $(".grid-blog-slider").trigger("prev.owl")
  })

  $("body:not(.rtl) .widget_top_rated_products .top-products").owlCarousel({
    items: 1,
    nav: !1,
    dots: !0,
    loop: !0,
    autoplay: !0,
    rtl: !1,
    responsive: {
      1279: {
        items: 1,
      },
      1250: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  })
  $("body.rtl .widget_top_rated_products .top-products").owlCarousel({
    items: 1,
    nav: !1,
    dots: !0,
    loop: !0,
    autoplay: !0,
    rtl: !0,
    responsive: {
      1279: {
        items: 1,
      },
      1250: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  })

  $("body:not(.rtl) .ttleft-testimonial-wrap .testimonials_wrap").owlCarousel({
    items: 1,
    nav: true,
    dots: true,
    loop: true,
    autoplay: true,
    rtl: false,
    responsive: {
      1279: {
        items: 1,
      },
      1250: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  })
  $("body.rtl .ttleft-testimonial-wrap .testimonials_wrap").owlCarousel({
    items: 1,
    nav: true,
    dots: true,
    loop: true,
    autoplay: true,
    rtl: true,
    responsive: {
      1279: {
        items: 1,
      },
      1250: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  })

  var brandsowl = $("body:not(.rtl) #brands_list_slider")
  var brandsowlrtl = $("body.rtl #brands_list_slider")
  brandsowl.owlCarousel({
    items: 6,
    dots: false,
    loop: false,
    autoplay: true,
    autoplaySpeed: 1500,
    autoplayHoverPause: true,
    nav: true,
    responsive: {
      320: {
        items: 2,
      },
      544: {
        items: 3,
      },
      992: {
        items: 4,
      },
      1200: {
        items: 5,
      },
      1630: {
        items: 6,
      },
    },
  })
  brandsowlrtl.owlCarousel({
    items: 6,
    dots: false,
    loop: false,
    nav: true,
    autoplay: true,
    autoplaySpeed: 1500,
    autoplayHoverPause: true,
    rtl: true,
    responsive: {
      320: {
        items: 2,
      },
      544: {
        items: 3,
      },
      992: {
        items: 4,
      },
      1200: {
        items: 5,
      },
      1630: {
        items: 6,
      },
    },
  })

  $(".brand-bar").each(function () {
    if ($(this).find(".owl-nav").hasClass("disabled")) {
      $(this).find(".customNavigation").hide()
    } else {
      $(this).find(".customNavigation").show()
    }
  })
  $(".brand_next").click(function () {
    $(".tt-brand_slider").trigger("next.owl")
  })
  $(".brand_prev").click(function () {
    $(".tt-brand_slider").trigger("prev.owl")
  })

  $("body:not(.rtl) #ttcmsservices .block_content").owlCarousel({
    items: 4,
    nav: true,
    dots: true,
    loop: true,
    autoplay: true,
    rtl: false,
    responsive: {
      1279: {
        items: 4,
      },
      992: {
        items: 4,
      },
      481: {
        items: 3,
      },
      100: {
        items: 1,
      },
    },
  })
  $("body.rtl #ttcmsservices .block_content").owlCarousel({
    items: 4,
    nav: true,
    dots: true,
    loop: true,
    autoplay: true,
    rtl: true,
    responsive: {
      1279: {
        items: 4,
      },
      992: {
        items: 4,
      },
      481: {
        items: 3,
      },
      100: {
        items: 1,
      },
    },
  })

  $(".dt-menu-expand").click(function (event) {
    event.preventDefault()
    if ($(this).hasClass("dt-mean-clicked")) {
      $(this).text("+")
      if ($(this).prev("ul").length) {
        $(this).prev("ul").slideUp(400)
      } else {
        $(this).prev(".megamenu-child-container").find("ul:first").slideUp(600)
      }
    } else {
      $(this).text("-")
      if ($(this).prev("ul").length) {
        $(this).prev("ul").slideDown(400)
      } else {
        $(this)
          .prev(".megamenu-child-container")
          .find("ul:first")
          .slideDown(2000)
      }
    }

    $(this).toggleClass("dt-mean-clicked")
    return false
  })

  $("body:not(.rtl) .testimonial-wrap .testimonials_wrap").owlCarousel({
    items: 1,
    nav: true,
    dots: true,
    loop: true,
    autoplay: true,
    rtl: false,
    responsive: {
      1279: {
        items: 1,
      },
      1250: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  })

  $("body.rtl .testimonial-wrap .testimonials_wrap").owlCarousel({
    items: 1,
    nav: true,
    dots: true,
    loop: true,
    autoplay: true,
    rtl: true,
    responsive: {
      1279: {
        items: 1,
      },
      1250: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  })

  $("body:not(.rtl) #tt-megamenu .list_product_menu_content").owlCarousel({
    items: 3,
    nav: true,
    autoPlay: true,
    autoplaySpeed: 1000,
    stopOnHover: false,
    loop: false,
    dots: true,
    responsive: {
      992: {
        items: 3,
      },
      481: {
        items: 2,
      },
      100: {
        items: 1,
      },
    },
  })

  $("body.rtl #tt-megamenu .list_product_menu_content").owlCarousel({
    items: 3,
    nav: true,
    autoPlay: true,
    autoplaySpeed: 1000,
    rtl: true,
    stopOnHover: false,
    loop: false,
    dots: true,
    responsive: {
      992: {
        items: 3,
      },
      481: {
        items: 2,
      },
      100: {
        items: 1,
      },
    },
  })

  $("body:not(.rtl) .collection_cms_slider").owlCarousel({
    nav: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 1500,
    loop: false,
    responsive: {
      100: {
        items: 1,
      },
      370: {
        items: 2,
      },
      555: {
        items: 3,
      },
      768: {
        items: 4,
      },
      992: {
        items: 5,
      },
      1260: {
        items: 6,
      },
      1660: {
        items: 7,
      },
    },
  })

  $("body.rtl .collection_cms_slider").owlCarousel({
    nav: true,
    rtl: true,
    loop: true,
    autoplay: true,
    autoplaySpeed: 1500,
    dots: false,
    responsive: {
      100: {
        items: 1,
      },
      370: {
        items: 2,
      },
      555: {
        items: 3,
      },
      768: {
        items: 4,
      },
      992: {
        items: 5,
      },
      1260: {
        items: 6,
      },
      1660: {
        items: 7,
      },
    },
  })

  if (jQuery(".collection_cms_slider .owl-nav").hasClass("disabled")) {
    jQuery(".collection_cms_slider_wrap .customNavigation").hide()
  } else {
    jQuery(".collection_cms_slider_wrap .customNavigation").show()
  }

  jQuery(".collection_cms_slider_wrap .customNavigation .next").click(
    function () {
      jQuery(".collection_cms_slider_wrap .collection_cms_slider").trigger(
        "next.owl"
      )
    }
  )
  jQuery(".collection_cms_slider_wrap .customNavigation .prev").click(
    function () {
      jQuery(".collection_cms_slider_wrap .collection_cms_slider").trigger(
        "prev.owl"
      )
    }
  )
})

function moremenu() {
  var max_elem = 3
  var items = jQuery(
    ".header_1 .topmenu #accessibleNav > li, .header_2 .topmenu #accessibleNav > li"
  )
  var surplus = items.slice(max_elem, items.length)

  surplus.wrapAll(
    '<li class="more_menu site-nav--has-dropdown menu-item-depth-0"><ul class="top-link sub-nav__dropdown sub-menu mobile-nav__sublist">'
  )

  jQuery(".more_menu").prepend(
    '<a href="#" class="level-top topmega-menu-link">More</a>'
  )

  jQuery(".more_menu").mouseover(function () {
    jQuery(this).children("ul").addClass("shown-link")
  })

  jQuery(".more_menu").mouseout(function () {
    jQuery(this).children("ul").removeClass("shown-link")
  })
}

jQuery(document).ready(function () {
  moremenu()
})

function moremenuThird() {
  var max_elem = 2
  var items = jQuery(".header_3 .topmenu #accessibleNav > li")
  var surplus = items.slice(max_elem, items.length)

  surplus.wrapAll(
    '<li class="more_menuTh site-nav--has-dropdown menu-item-depth-0"><ul class="top-link sub-nav__dropdown sub-menu mobile-nav__sublist">'
  )

  jQuery(".more_menuTh").prepend(
    '<a href="#" class="level-top topmega-menu-link">More</a>'
  )

  jQuery(".more_menuTh").mouseover(function () {
    jQuery(this).children("ul").addClass("shown-link")
  })

  jQuery(".more_menuTh").mouseout(function () {
    jQuery(this).children("ul").removeClass("shown-link")
  })
}

jQuery(document).ready(function () {
  moremenuThird()
})

jQuery(window).scroll(function () {
  if (jQuery(document).height() > jQuery(window).height()) {
    var scroll = jQuery(window).scrollTop()

    if (scroll > 100) {
      jQuery("#GotoTop").fadeIn()
    } else {
      jQuery("#GotoTop").fadeOut()
    }
  }
})

function responsiveMenu() {
  if (jQuery(window).width() < 992) {
    jQuery(".Site-navigation").insertAfter(".nav-toggle")
    jQuery(".sub-nav__dropdown").css("display", "none")
  } else {
    jQuery(".Site-navigation").appendTo(".menu_wrapper")
  }

  if (jQuery(window).width() < 992) {
    $("#shopify-section-TT-mega_menu").appendTo(".menu-bar .ttresponsive_menu")
    $("#accessibleNav").appendTo("#tt-megamenu .tt_menus_ul")
    $(".header_1 .header-right-cms").appendTo("#tt-megamenu .tt_menus_ul")
    $(".header_2 .cms-contactus").appendTo("#tt-megamenu .tt_menus_ul")
    $(".header_1 .header-middle").insertBefore(".ttresponsive_menu-wrap")
    $(".header_1 .myaccount").insertAfter(".header-middle")
    $(".header_1 .ttcmsheader").insertBefore(".header-right-cms")
  } else {
    $(".header_style_1 #shopify-section-TT-mega_menu").insertBefore(
      ".header_style_1 .header-middle"
    )
    $(".header_style_2 #shopify-section-TT-mega_menu").insertBefore(
      ".header_style_2 .topmenu"
    )
    $("#tt-megamenu .tt_menus_ul .header-right-cms").insertBefore(
      ".full-header .header-middle"
    )
    $("#tt-megamenu .tt_menus_ul #accessibleNav").appendTo(".topmenu")
    $(".header_style_1 .menu-bar .myaccount").insertBefore(
      ".header_style_1 .full-header .topmenu"
    )
    $(".header_style_1 #tt-megamenu .ttcmsheader").insertBefore(
      ".header_style_1 .full-header .topmenu"
    )
  }
}

jQuery(document).ready(function () {
  responsiveMenu()

  jQuery(".product-write-review").on("click", function (e) {
    e.preventDefault()
    $("a[href='#tab-2']").trigger("click")
    jQuery("html, body").animate(
      {
        scrollTop: jQuery(".product_tab_wrapper").offset().top - 150,
      },
      1000
    )
  })
})

jQuery(window).resize(function () {
  responsiveMenu()
  var w_width = $(window).width()
  $(".slider-content-main-wrap").css("width", w_width)
})

function footerToggle() {
  if (jQuery(window).width() < 992) {
    jQuery(".header-right").appendTo(".ttresponsive_menu")
  } else {
    jQuery(".ttresponsive_menu .header-right").insertAfter(".header-left")
  }
  if (jQuery(window).width() < 992) {
    if ($(".left-sidebar-menu").length > 0) {
      jQuery(".left-sidebar-menu").appendTo(".ttresponsive_menu")
      jQuery(".header-right").appendTo(".ttresponsive_menu")

      jQuery(".ttresponsive_menu h4.widget-title").unbind("click")
      jQuery(".ttresponsive_menu  h4.widget-title").on("click", function () {
        jQuery(this)
          .parent()
          .toggleClass("active")
          .children(":nth-child(2)")
          .slideToggle("fast")
      })
    } else {
      jQuery("nav#menu .nav-menu-wrapper").appendTo(".ttresponsive_menu")
      jQuery(".nav-menu-wrapper h4.widget-title").unbind("click")
      jQuery(".nav-menu-wrapper h4.widget-title").on("click", function () {
        jQuery(this)
          .parent()
          .toggleClass("active")
          .children(":nth-child(2)")
          .slideToggle("fast")
      })
    }

    jQuery("#column-left").insertAfter("#content")
    if (jQuery(".site-footer").hasClass("fixed_footer")) {
      jQuery(".page-wrapper").css("margin-bottom", "0px")
    }
    jQuery(".left-sidebar.sidebar").insertAfter(
      ".collection_wrapper, .content-wrapper"
    )
    jQuery(".sidebar .sidebar-block").insertAfter(".filter-wrapper")
    jQuery(
      ".both_sidebar .sidebar#column-left .collection_sidebar"
    ).insertAfter(".filter-wrapper")
    jQuery(".site-footer .footer-column h5").addClass("toggle")
    jQuery(".site-footer .footer-column")
      .children(":nth-child(2)")
      .css("display", "none")
    jQuery(".site-footer .footer-column.active")
      .children(":nth-child(2)")
      .css("display", "block")
    jQuery(".site-footer .footer-column h5.toggle").unbind("click")
    jQuery(".site-footer .footer-column h5.toggle").on("click", function () {
      jQuery(this)
        .parent()
        .toggleClass("active")
        .children(":nth-child(2)")
        .slideToggle("fast")
    })
    jQuery(".site-footer .widget h5").addClass("toggle")
    jQuery(".site-footer .widget")
      .children(":nth-child(2)")
      .css("display", "none")
    jQuery(".site-footer .widget.active")
      .children(":nth-child(2)")
      .css("display", "block")
    jQuery(".site-footer .widget h5.toggle").unbind("click")
    jQuery(".site-footer .widget h5.toggle").on("click", function () {
      jQuery(this)
        .parent()
        .toggleClass("active")
        .children(":nth-child(2)")
        .slideToggle("fast")
    })
    jQuery(".sidebar .widget > h4").addClass("toggle")
    jQuery(".sidebar .widget ").children(":nth-child(2)").css("display", "none")
    jQuery(".sidebar .widget.active")
      .children(":nth-child(2)")
      .css("display", "block")
    jQuery(".sidebar .widget > h4.toggle").unbind("click")
    jQuery(".sidebar .widget > h4.toggle").on("click", function () {
      jQuery(this)
        .parent()
        .toggleClass("active")
        .children(":nth-child(2)")
        .slideToggle("fast")
    })
    jQuery(".sidebar-block .widget > h4").addClass("toggle")
    jQuery(".sidebar-block .widget ")
      .children(":nth-child(2)")
      .css("display", "none")
    jQuery(".sidebar-block .widget.active")
      .children(":nth-child(2)")
      .css("display", "block")
    jQuery(".sidebar-block .widget > h4.toggle").unbind("click")
    jQuery(".sidebar-block .widget > h4.toggle").on("click", function () {
      jQuery(this)
        .parent()
        .toggleClass("active")
        .children(":nth-child(2)")
        .slideToggle("fast")
    })
  } else {
    if ($(".left-sidebar-menu").length > 0) {
      jQuery("#accessibleNav").appendTo(".nav-menu-wrapper .navbar-collapse")
    } else {
      jQuery(".ttresponsive_menu .nav-menu-wrapper").appendTo("nav#menu")
    }
    jQuery(".left-sidebar-menu").appendTo("#shopify-section-left-col-menu")
    jQuery("#column-left").insertBefore("#content")
    jQuery(".sidebar .sidebar-block").insertAfter(
      "#shopify-section-left-col-menu"
    )
    jQuery(".both_sidebar .sidebar#column-left .sidebar-block").prependTo(
      ".collection_sidebar"
    )
    jQuery(".section-header .sidebar-block").prependTo(".collection_sidebar")
    if (jQuery(".site-footer").hasClass("fixed_footer")) {
      var footer_h = jQuery(".site-footer.fixed_footer").height()
      jQuery(".page-wrapper").css("margin-bottom", footer_h + "px")
    }
    jQuery(".left-sidebar.sidebar").insertBefore(
      ".collection_wrapper, .content-wrapper"
    )
    jQuery(".sidebar .widget > h4").unbind("click")
    jQuery(".sidebar .widget > h4").removeClass("toggle")
    jQuery(".sidebar .widget").children(":nth-child(2)").css("display", "block")

    jQuery(".site-footer .footer-column h5").unbind("click")
    jQuery(".site-footer .footer-column h5").removeClass("toggle")
    jQuery(".site-footer .footer-column")
      .children(":nth-child(2)")
      .css("display", "block")
    jQuery(".site-footer .widget h5").unbind("click")
    jQuery(".site-footer .widget h5").removeClass("toggle")
    jQuery(".site-footer .widget")
      .children(":nth-child(2)")
      .css("display", "block")
  }
}

jQuery(document).ready(function () {
  footerToggle()
  sidebarsticky()
})

jQuery(window).load(function () {
  var h = $(".design_4 .product-wrapper-owlslider").height()
  $(".design_4 .product-information-inner.tt-scroll").css(
    "min-height",
    h + "px"
  )
})

jQuery(window).resize(function () {
  footerToggle()
  var h = $(".design_4 .product-wrapper-owlslider").height()
  $(".design_4 .product-information-inner.tt-scroll").css(
    "min-height",
    h + "px"
  )
})

function splitStr(string, seperator) {
  return string.split(seperator)
}

function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this)
    var promoperiod

    if (countdown.attr("data-promoperiod")) {
      promoperiod =
        new Date().getTime() + parseInt(countdown.attr("data-promoperiod"), 10)
    } else if (countdown.attr("data-countdown")) {
      promoperiod = countdown.attr("data-countdown")
    }

    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      countdown.countdown(promoperiod, function (event) {
        countdown.html(
          event.strftime(
            '<span><span class="left-txt">LEFT</span><span>%D</span><span class="time-txt">days</span></span>' +
              '<span><span>%H</span><span class="time-txt">hours</span></span>' +
              '<span><span>%M</span><span class="time-txt">min</span></span>' +
              '<span><span class="second">%S</span><span class="time-txt">sec</span></span>'
          )
        )
      })
    }
  })
}

function countDownProductIni(countdown) {
  var labels = ["days", "hours", "minutes", "seconds"],
    $countdown = $(countdown),
    promoperiod,
    template = _.template(
      '<div class="time <%= label %>"><span class="count curr top"><%= curr %></span><span class="count next top"><%= next %></span><span class="count next bottom"><%= next %></span><span class="count curr bottom"><%= curr %></span><span class="label"><%= label.length < 6 ? label : label.substr(0, 3)  %></span></div>'
    ),
    currDate = "00:00:00:00",
    nextDate = "00:00:00:00"
  if ($countdown.attr("data-promoperiod")) {
    promoperiod =
      new Date().getTime() + parseInt($countdown.attr("data-promoperiod"), 10)
  }
  if ($countdown.attr("data-countdown")) {
    promoperiod = $countdown.attr("data-countdown")
  }

  function strfobj(str) {
    var parsed = str.split(":"),
      obj = {}
    labels.forEach(function (label, i) {
      obj[label] = parsed[i]
    })
    return obj
  }

  function diff(obj1, obj2) {
    var diff = []
    labels.forEach(function (key) {
      if (obj1[key] !== obj2[key]) {
        diff.push(key)
      }
    })
    return diff
  }
  var initData = strfobj(currDate)
  labels.forEach(function (label, i) {
    $countdown.append(
      template({
        curr: initData[label],
        next: initData[label],
        label: label,
      })
    )
  })
  $countdown.countdown(promoperiod, function (event) {
    var newDate = event.strftime("%D:%H:%M:%S"),
      data
    if (newDate !== nextDate) {
      currDate = nextDate
      nextDate = newDate
      data = {
        curr: strfobj(currDate),
        next: strfobj(nextDate),
      }
      diff(data.curr, data.next).forEach(function (label) {
        var selector = ".%s".replace(/%s/, label),
          $node = $countdown.find(selector)
        $node.removeClass("flip")
        $node.find(".curr").text(data.curr[label])
        $node.find(".next").text(data.next[label])
        _.delay(
          function ($node) {
            $node.addClass("flip")
          },
          50,
          $node
        )
      })
    }
  })
}

function hb_animated_contents() {
  $(".hb-animate-element:in-viewport").each(function (i) {
    var $this = $(this)
    if (!$this.hasClass("hb-in-viewport")) {
      setTimeout(function () {
        $this.addClass("hb-in-viewport")
      }, 180 * i)
    }
  })
}

$(window).scroll(function () {
  hb_animated_contents()
})
$(window).load(function () {
  hb_animated_contents()
})

function sidebarsticky() {
  if ($(document).width() > 992 && $(document).width() < 1199) {
    jQuery(
      "#column-left,.no_sidebar .left-sidebar.sidebar,.no_sidebar .right-sidebar.sidebar"
    ).theiaStickySidebar({
      additionalMarginBottom: 30,
      additionalMarginTop: 30,
    })
  } else if ($(document).width() >= 1200) {
    jQuery(
      "#column-left,.no_sidebar .left-sidebar.sidebar,.no_sidebar .right-sidebar.sidebar"
    ).theiaStickySidebar({
      additionalMarginBottom: 30,
      additionalMarginTop: 130,
    })
  }
}

jQuery(window).resize(function () {
  sidebarsticky()
})
